import { render, staticRenderFns } from "./BasicTabs.vue?vue&type=template&id=0e4ee16e"
import script from "./BasicTabs.vue?vue&type=script&lang=js"
export * from "./BasicTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports